export const ROUTES = {
  BASE: "/",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  ABOUT_US: "/sobre-nos",
  PRIVACY_POLICY: "/politique-de-confidentialite",
  GAMES: "/jogos",
  CONTACT: "/contate-nos",
  
  COOKIES_POLICY: "/cookies-policy",
};